import React from 'react';

export interface ButtonGroupOption {
  label: string;
  value: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export interface ButtonGroupProps {
  options: ButtonGroupOption[];
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  size?: 'sm' | 'md';
}

export default function ButtonGroup({
  options,
  value,
  onChange,
  className = '',
  size = 'md'
}: ButtonGroupProps) {
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm';

  return (
    <span className={`isolate inline-flex rounded-md shadow-sm ${className}`}>
      {options.map((option, index) => {
        const isFirst = index === 0;
        const isLast = index === options.length - 1;
        const isSelected = value === option.value;
        const Icon = option.icon;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange?.(option.value)}
            className={`
              relative inline-flex items-center ${sizeClasses} font-semibold
              ${isFirst ? 'rounded-l-md' : '-ml-px'}
              ${isLast ? 'rounded-r-md' : ''}
              ${
                isSelected
                  ? 'bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600 hover:bg-indigo-700'
                  : 'bg-panel text-heading ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-highlight'
              }
              focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-600
            `}
          >
            {Icon && <Icon className={`${option.label ? 'mr-2' : ''} h-4 w-4`} />}
            {option.label}
          </button>
        );
      })}
    </span>
  );
}
